import { MessageSquare, Smartphone, Phone } from "lucide-react";

const WhatMakesDifferent = () => {
  const differentiators = [
    {
      icon: MessageSquare,
      title: "Clear positioning",
      description: "Visitors immediately understand who you are, what you do, and why you're different — no guessing, no digging.",
    },
    {
      icon: Smartphone,
      title: "Modern, mobile-first",
      description: "Designed for how clients actually browse — quickly, on their phones, between showings and calls.",
    },
    {
      icon: Phone,
      title: "Built for contact",
      description: "Every page makes it clear how to reach you — without pop-ups, pressure, or distractions.",
    },
  ];

  return (
    <section className="section-padding bg-section-alt">
      <div className="container-narrow">
        <div className="text-center mb-12">
          <h2 data-reveal className="text-3xl md:text-4xl font-semibold mb-4 text-primary">
            What makes Site Elevation different
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {differentiators.map((item, index) => (
            <div key={index} data-reveal style={{ transitionDelay: `${100 + index * 120}ms` }} className="text-center">
              <div className="w-10 h-10 mx-auto mb-5 flex items-center justify-center">
                <item.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-lg font-semibold mb-3 text-foreground">
                {item.title}
              </h3>
              <p className="text-soft leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatMakesDifferent;
